import styled from 'styled-components';
import { max } from '../../lib/responsive';
import { H3, SubH } from '../../style/typography';

const SponsorshipContainer = styled.div`
  width: 100%;
`;

const SponsorshipHeadingContainer = styled.div`
  width: 75%;
  margin: auto;
`;

const SponsorshipHeading = styled(H3)`
  text-align: center;
  letter-spacing: 0.01em;
  margin-top: 10.75rem;

  @media ${max.tablet} {
    display: none;
  }
`;

const MobileSponsorshipHeading = styled(SubH)`
  display: none;

  @media ${max.tablet} {
    text-align: center;
    display: block;
    letter-spacing: 0.01em;
    text-transform: lowercase;
    margin-top: 4rem;
  }
`;

const SponsorshipImageDesktop = styled.img`
  display: block;
  max-width: 80%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  margin-top: 7.313rem;
  margin-bottom: 10.25rem;

  @media ${max.tablet} {
    display: none;
  }
`;

const SponsorshipImageMobile = styled.img`
  display: none;

  @media ${max.tablet} {
    margin-top: 4.313rem;
    display: block;
    max-width: 80%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10.25rem;
  }
`;

export {
  SponsorshipContainer,
  SponsorshipHeadingContainer,
  SponsorshipHeading,
  MobileSponsorshipHeading,
  SponsorshipImageDesktop,
  SponsorshipImageMobile,
};
